import axios from "axios";
import { loginRequest } from "./authConfig";

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000'; // Added default for local testing

async function getToken(instance, accounts) {
  const response = await instance.acquireTokenSilent({
    ...loginRequest,
    account: accounts[0],
  });
  return response.accessToken;
}

async function fetchStatus(selectedEnvironment, instance, accounts) {
  try {
    const token = await getToken(instance, accounts);
    const apiResponse = await axios.post(
      `${API_URL}/api/status`,
      { domain: selectedEnvironment },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        timeout: 10000, // Add a 10 second timeout
      }
    );
    
    // Ensure we have valid data even if the API returns an empty object
    return apiResponse.data || {};
  } catch (error) {
    console.error("Error in fetchStatus:", error);
    // Return empty object instead of throwing, so the component can handle it
    return {};
  }
}

async function fetchStatusDetails(date, projectIdentifier, domain, instance, accounts) {
  try {
    const token = await getToken(instance, accounts);
    const apiResponse = await axios.post(
      `${API_URL}/api/status-details`,
      { date, project_identifier: projectIdentifier, domain },
      {
        headers: { 
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        timeout: 10000, // Add a 10 second timeout
      }
    );
    return apiResponse.data;
  } catch (error) {
    console.error("Error in fetchStatusDetails:", error);
    throw error;
  }
}

export { fetchStatus, fetchStatusDetails };
